// eslint-disable-next-line import/no-webpack-loader-syntax
module.exports = require('./lib/bootstrap.loader!./no-op.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-loader/loader.js
// module id = wPPq
// module chunks = 3 5